<template>
  <div class="module-title">
    <div class="line" v-if="!noLine"/>
    <span class="module-line-title"><slot>{{ title }}</slot></span>
    <span class="tips" v-if="$slots.tips">
      <slot name="tips"></slot>
    </span>
    <span class="btn" v-if="$slots.btn">
      <slot class="btn" name="btn"></slot>
    </span>
  </div>
</template>

<script>
export default {
  name: "ModuleTitle",
  props: {
    title: {
      type: String,
      default: "",
    },
    tips: {
      type: String,
      default: "",
    },
    noLine:{
      type:Boolean,
      default:true
    }
  },
};
</script>

<style lang="scss" scoped>
.module-title {
  &.form-title {
    margin-bottom: 21px;
  }

  &.bottom {
    margin-bottom: 24px;
  }
}
.module-title {
  font-size: 16px;
  font-weight: 600;
  color: $primaryColor;
  display:flex;
  align-items: center;
  .line {
    float: left;
    width: 4px;
    height: 16px;
    background: $primaryColor;
    margin-right: 10px;
    border-radius: 4px;
        // margin-top: 2px;
  }
  .module-line-title{
    display: inline-block;
    height:22px;
    line-height:22px;
  }
  .tips {
    font-size: 12px;
    color: rgba(20, 23, 47, 0.5);
    margin-left: 10px;
    font-weight: normal;
  }
  .btn {
    flex-grow: 1;
    text-align: right;
  }
  .ly-c-buttons{
    margin-bottom: 0;
    padding-right: 0;
    .el-button {
      padding: 9px 15px;
    }
  }
}
</style>
